<template>
  <div id="steps" class="wrapper">
    <div class ="wrapper1">
        <div class="text">
        <h2>Как это работает?</h2>


<ul>
  
  <li><div class="decor">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'sircle'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="5" cy="5" r="5" fill="#5F2EEA"/></svg>
        <svg width="78" height="2" viewBox="0 0 78 2" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'line'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" stroke="#5F2EEA" stroke-width="2" stroke-linecap="round" stroke-dasharray="2 8" d="M1 1h76"/></svg>
        </div>Вводите свои данные<br><span>Занимает не больше 5 минут<br>
времени</span></li>

  <li><div class="decor">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'sircle'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="5" cy="5" r="5" fill="#5F2EEA"/></svg>
        <svg width="78" height="2" viewBox="0 0 78 2" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'line'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" stroke="#5F2EEA" stroke-width="2" stroke-linecap="round" stroke-dasharray="2 8" d="M1 1h76"/></svg>
        </div>Ожидайте 10 минут<br><span>Далее ожидайте результатов<br> заявки</span></li>
 
  <li><div class="decor">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'sircle'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="5" cy="5" r="5" fill="#5F2EEA"/></svg>
        <svg width="78" height="2" viewBox="0 0 78 2" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'line'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" stroke="#5F2EEA" stroke-width="2" stroke-linecap="round" stroke-dasharray="2 8" d="M1 1h76"/></svg>
        </div>Получите кредитную карту<br><span>К вам приедет наш менеджер<br> и доставит карту</span></li>
  </ul>


        <!-- <div class="decor">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="5" cy="5" r="5" fill="#5F2EEA"/></svg>
        <svg width="78" height="2" viewBox="0 0 78 2" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'line'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" stroke="#5F2EEA" stroke-width="2" stroke-linecap="round" stroke-dasharray="2 8" d="M1 1h76"/></svg>
        </div>
        <h3>Вводите свои данные</h3>
        <p>Занимает не больше 5 минут<br>
времени</p>
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'marker'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="5" cy="5" r="5" fill="#5F2EEA"/></svg>
        <h3>Ожидайте 10 минут</h3>
        <p>Далее ожидайте результатов<br> заявки</p>
        <div class="decor">
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><circle cx="5" cy="5" r="5" fill="#5F2EEA"/></svg>
        <svg width="78" height="2" viewBox="0 0 78 2" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'line'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path opacity=".4" stroke="#5F2EEA" stroke-width="2" stroke-linecap="round" stroke-dasharray="2 8" d="M1 1h76"/></svg>
        </div>
        <h3>Получите кредитную карту</h3>
        <p>К вам приедет наш менеджер<br> и доставит карту</p>
         -->
     </div>
    </div>
   
  </div>
  
</template>

<script>
export default {
  name: 'steps',
}
</script>

<style scoped>
.decor{display: flex; padding-bottom: 5vw; padding-top: 7vw;}
.line{padding-left: 9vw}
li{font-size: 4vw; padding-bottom: 1vw;font-weight: bold;}
.marker{padding-bottom: 5vw; padding-top: 7vw;}
.text{padding-top:15vw; padding-bottom: 15vw;}
.wrapper1{padding-left: 14vw; padding-right: 14vw;}
   span{font-weight:normal;}

 @media screen and (min-width: 760px) {
   .line {width: 131px; height:18px;padding-left: 38px;}
.sircle{width: 18px; height:18px;}
 }

 @media screen and (min-width: 1040px) {
   h2{font-size:23px;}
   li{font-size:16px; }
   span{font-weight:normal; }
   p{font-size:15px;}
   .wrapper1{padding-left: 0vw; padding-right: 0vw;}
ul{display: grid; grid-template-columns: 1fr 1fr 245px;}
.line {width: 131px; height:18px;padding-left: 38px;}
.sircle{width: 18px; height:18px;}
.decor{padding-bottom: 26px; padding-top: 30px;}
.text{padding-top: 80px;padding-bottom: 52px;}
 }

</style>
